import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Column } from "../models/Column";

interface IUseColumn {
  id: string;
}

export const useColumn = ({
  id,
}: IUseColumn): { fetch: UseFetchResult<Column> } => {
  const fetch = useFetch<Column>(`/api/columns/${id}`, {
    skipInitialFetch: !id,
  });

  return { fetch };
};
